/* Alma Silvestre: textos en inglés para /en */
(function(){
  if(!/^en/i.test(document.documentElement.lang||'')) return;
  document.querySelectorAll('label.alma-consent').forEach(function(l){
    var a=l.querySelector('a');var href=a?a.getAttribute('href'):'/policies/privacy-policy';
    var i=l.querySelector('input');l.textContent='';if(i)l.appendChild(i);
    l.appendChild(document.createTextNode(' I agree to the processing of my personal data under the '));
    var n=document.createElement('a');n.href=href;n.textContent='privacy policy';l.appendChild(n);l.appendChild(document.createTextNode('.'));
  });
})();
/* Alma Silvestre: botón de compra fijo en móvil */
(function(){
  if(!document.querySelector('product-info')) return;
  var form=document.querySelector('product-info product-form form')||document.querySelector('product-info form[data-type="add-to-cart-form"]');
  var btn=form&&form.querySelector('[type=submit][name=add]');
  if(!btn) return;
  var label=function(){var s=btn.querySelector('span');return ((s||btn).textContent||'').trim();};
  var title=(document.querySelector('.product__title h1')||{}).textContent||'';
  var bar=document.createElement('div');bar.className='alma-sticky-atc';bar.setAttribute('aria-hidden','true');
  bar.innerHTML='<div class="alma-sticky-atc__info"><strong></strong><span class="alma-sticky-atc__price"></span></div><button type="button" class="button button--primary"></button>';
  bar.querySelector('strong').textContent=title.trim();
  bar.inert=true;document.body.appendChild(bar);
  function price(){var p=document.querySelector('product-info .price__sale .price-item--sale, product-info .price__regular .price-item--regular');bar.querySelector('.alma-sticky-atc__price').textContent=p?p.textContent.trim():'';
    var b=bar.querySelector('button');b.disabled=btn.disabled;b.textContent=label();}
  price();
  if(typeof subscribe==='function'&&window.PUB_SUB_EVENTS){subscribe(PUB_SUB_EVENTS.variantChange,function(){setTimeout(price,50)});}else{document.addEventListener('change',function(){setTimeout(price,400)});}
  bar.querySelector('button').addEventListener('click',function(){btn.click();});
  new IntersectionObserver(function(e){var show=!e[0].isIntersecting&&e[0].boundingClientRect.top<0;bar.classList.toggle('is-visible',show);document.body.classList.toggle('alma-sticky-on',show);bar.setAttribute('aria-hidden',show?'false':'true');bar.inert=!show;}).observe(btn);
})();
